import { render, staticRenderFns } from "./tabComp2.vue?vue&type=template&id=723b8001&scoped=true&"
import script from "./tabComp2.vue?vue&type=script&lang=js&"
export * from "./tabComp2.vue?vue&type=script&lang=js&"
import style0 from "./tabComp2.vue?vue&type=style&index=0&id=723b8001&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b8001",
  null
  
)

export default component.exports